import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

function LoginCallbackPage() {
    const location = useLocation();

    useEffect(() => {
        const portalUrl = `https://portal.sqarplan.com/login/callback${location.search}`;
        window.location.href = portalUrl;
    }, [location]);

    return (
        <div style={{ 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center', 
            height: '100vh',
            width: '100vw',
            fontSize: '24px'
        }}>
            Redirecting to portal...
        </div>
    );
}

export default LoginCallbackPage;